<div>
  <temp-object-picker
    [(ngModel)]="picked"
    [name]="fieldKey"
    [placeholder]="fieldName"
    [required]="isRequired && !noValidate"
    [fieldDefinition]="fieldDefinition"
    [externalObjectDefinition]="externalObjectDefinition"
    [disabled]="isDisabled"
    [multiple]="multiple"
    [isSubmitted]="isSubmitted"
    [isTable]="isTable"
    #model="ngModel"
  ></temp-object-picker>
</div>

<div class="d-flex justify-content-between p-3 border-top">
  <div
    class="text-danger w-100"
    *ngIf="
      isSubmitted && isRequired && (!picked || (multiple && !picked.length))
    "
  >
    {{ 'shared.general.atLeastOne' | translate }}
  </div>
  <div class="d-flex justify-content-end w-100">
    <button
      type="button"
      class="btn btn-outline-secondary mr-2"
      (click)="cancel()"
    >
      {{ 'shared.terms.cancel' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="confirm()">
      {{ 'shared.terms.select' | translate }}
    </button>
  </div>
</div>
